var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getVisible)?_c('v-alert',{staticClass:"mx-auto",attrs:{"max-width":"800","value":_vm.getMessage !== null,"type":"warning","outlined":"","prominent":""}},[_vm._v(" "+_vm._s(_vm.getMessage)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }